import { toJSON } from '../Utils';

export const handleLoginService = (function() {
    const settings = {
        token: 'TonaAccessToken',
    };

    const _composition = data => ({
        map: f => _composition(f(data)),
        fold: f => f(data),
    });

    function saveInLocalStorage(data, key = settings.token) {
        if (typeof data === 'object') {
            const json = toJSON(data);
            window.localStorage.setItem(key, json);
        }
    }

    function removeFromLocalStorage(key = settings.token) {
        const isExistDataInLocalStorage = window.localStorage[settings.token].length > 0;

        if (isExistDataInLocalStorage) {
            window.localStorage.removeItem(key);
        }
    }

    function retriveDataFromLocalStorage(value, key = settings.token) {
        return _composition({ value, key })
            .map(({ key, value }) => ({
                userInfoJson: getFromLocalStorage(key),
                value,
            }))
            .map(({ userInfoJson, value }) => ({
                user: JSON.parse(userInfoJson),
                value,
            }))
            .fold(({ user, value }) => {
                return user && value in user ? user[value] : undefined;
            });
    }

    function updateDataInLocalStorage(newObject) {
        _composition(settings.token)
            .map(key => getFromLocalStorage(key))
            .map(json => JSON.parse(json))
            .map(data => Object.assign(data, newObject))
            .fold(updatedData => saveInLocalStorage(updatedData));
    }

    function getFromLocalStorage(key) {
        return window.localStorage.getItem(key);
    }

    return {
        setAccount({ access_token, user_id, fullname, type }) {
            return saveInLocalStorage({
                access_token,
                user_id,
                fullname,
                type,
            });
        },
        removeAccount: removeFromLocalStorage,
        saveInLocalStorage,
        getAccessToken() {
            return retriveDataFromLocalStorage('access_token');
        },
        getUserId() {
            const userId = retriveDataFromLocalStorage('user_id') || '';
            return userId.toString();
        },
        getFullName() {
            return retriveDataFromLocalStorage('fullname');
        },
        getUserType() {
            return retriveDataFromLocalStorage('type');
        },
        updateDataInLocalStorage,
        isAuthenticated: function() {
            return !!(retriveDataFromLocalStorage('access_token') && retriveDataFromLocalStorage('access_token'));
        },
    };
})();

// for debug
window.userData = handleLoginService;



// WEBPACK FOOTER //
// ./src/Services/handleLocalStorage.js